import { redirectToHomeIfNoOffersAccess, redirectToHomeIfNotAnalyticsAccess } from '@/offers/router/guards';
import { ifNotAdminRedirectTo } from '@/router/common-guards';

const OffersPage = () => import('@/offers/pages/offers.vue');
const OfferPage = () => import('@/offers/pages/offer.vue');
const EditOfferPage = () => import('@/offers/pages/edit-offer.vue');
const CompetingOffersPage = () => import('@/offers/pages/competing-offers.vue');
const OfferAnalyticsPage = () => import('@/offers/pages/offer-analytics.vue');
const GreenhouseConnectionPage = () => import('@/offers/pages/greenhouse-connection.vue');
const OfferWritebackDebugPage = () => import('@/offers/pages/gh-debug-tools/offer-writeback.vue');

export const offersRoutes = [
  {
    path: '/offers',
    name: 'offers',
    component: OffersPage,
    beforeEnter: [redirectToHomeIfNoOffersAccess],
    meta: {
      layout: 'layout-offers-default',
    },
  },
  {
    path: '/offers/:id',
    name: 'offer',
    component: OfferPage,
    beforeEnter: [redirectToHomeIfNoOffersAccess],
    meta: {
      layout: 'layout-offers-default',
    },
  },
  {
    path: '/offers/:id/edit',
    name: 'offer-edit',
    component: EditOfferPage,
    beforeEnter: [redirectToHomeIfNoOffersAccess],
    meta: {
      layout: 'layout-default',
    },
  },
  {
    path: '/competing-offers',
    name: 'competing-offers',
    component: CompetingOffersPage,
    beforeEnter: [redirectToHomeIfNoOffersAccess],
    meta: {
      layout: 'layout-default',
    },
  },
  {
    path: '/offer-analytics',
    name: 'offer-analytics',
    component: OfferAnalyticsPage,
    beforeEnter: [redirectToHomeIfNotAnalyticsAccess],
    meta: {
      layout: 'layout-default',
    },
  },
  {
    path: '/candidate/:candidateId/applications/:applicationId',
    name: 'ats-candidate-application',
    component: GreenhouseConnectionPage,
    beforeEnter: [redirectToHomeIfNoOffersAccess],
    meta: {
      layout: 'layout-offers-default',
    },
  },
  {
    path: '/gh-debug-tools/offer-writeback',
    name: 'offer-writeback-debug-tool',
    component: OfferWritebackDebugPage,
    beforeEnter: [redirectToHomeIfNoOffersAccess, ifNotAdminRedirectTo('offers')],
    meta: {
      layout: 'layout-default',
    },
  },
];
